import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class UnitSwitcher extends ThemeComponent {
    @Ref selectUnit!: HTMLSelectElement;
    private _unitChange = new SimpleEvent<string>();

    public get unitChange() {
        return this._unitChange.asEvent();
    }

    init() {
        this.getUnitPreference(); // Set from localstorage.
        this.setEventListeners();
    }

    protected setEventListeners() {
        this.$listen(this.selectUnit, 'change', (e) => {
            const target = e.target as HTMLInputElement;
            this.updateSelectValue(target);
        });
    }

    getUnitPreference() {
        const units = localStorage.getItem("units") || 'mm';
        this.selectUnit.value = units;
        this._unitChange.dispatch('update');
    }

    updateUnitValue(newUnitValue: string) {
        return this.convertUnit(this.selectUnit.value, newUnitValue, true);
    }

    updateSelectValue(target:HTMLInputElement) {
        const newUnit = target.value;
        localStorage.setItem('units', newUnit);

        // Update select value of all unit switchers.
        const unitSwitchers = document.querySelectorAll('.unit-switcher') as NodeListOf<HTMLInputElement>;
        for (const unitSwitcher of unitSwitchers) {
            unitSwitcher.value = newUnit;
            this._unitChange.dispatch('update'); // Dispatch for components containing unit values.
        }

    }

    convertUnit(unit: string, unitValue: string, productType: boolean) {
        productType = (typeof productType === 'undefined') ? false : productType;

        // if (productType == true) {
        //     // console.log('productType: ' + productType);
        // } else {
        //     // console.log('productType Two: ' + productType);
        // }

        if(unitValue == undefined) { return ''; }
        let newFormat = '';

        if (productType) {
            const units = unitValue.split(' x ');

            for (let i = 0; i < units.length; i++) {
                // console.log('----' + unitAmount);
                if (units[i] && units[i].match(/\d+/)) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    const unitAmount = Number(units[i].match(/\d+/)[0]);

                    if (unit == 'mm') {
                        if (unitAmount > 5000) {
                            newFormat += (unitAmount / 1000).toFixed(0) + 'm';
                        } else {
                            newFormat += (unitAmount) + 'mm';
                        }
                    }

                    if (unit == 'inches') {
                        if (unitAmount > 5000) {
                            newFormat += (unitAmount / 304.8).toFixed(2) + 'ft';
                        } else {
                            newFormat += (unitAmount / 25.4).toFixed(1) + '"';
                        }
                    }

                    if (unit == 'cm') {
                        if (unitAmount > 5000) {
                            newFormat += (unitAmount / 1000).toFixed(0) + 'm';
                        } else {
                            newFormat += (unitAmount / 10).toFixed(0) + 'cm';
                        }
                    }

                    if (i != units.length - 1) {
                        newFormat += ' x ';
                    }

                }
            }
        } else {
            if (unit == "mm") {
                return unitValue;
            }

            const units = unitValue.split(" x ");

            for(let i = 0; i < units.length; i++){
                if (units[i] && units[i].match(/\d+/)) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    const unitAmount = Number(units[i].match(/\d+/)[0]);

                    if (unit == "inches") {
                        newFormat += (unitAmount / 25.4).toFixed(1) + '"';
                    }

                    if (unit == "cm") {
                        newFormat += (unitAmount / 10).toFixed(0) + 'cm';
                    }

                    if (i != units.length - 1){
                        newFormat += " x ";
                    }
                }
            }
        }

        return newFormat;
    }
}
